/* ==========================================================================
   PMG FEATURED PRODUCTS
   Handles the inline variant picker and the buy-now button.

   Deliberately does NOT handle add-to-cart. The cart drawer already
   intercepts every `form[action*="/cart/add"]` submit at the document level
   in the capture phase; adding a second handler here would post twice and
   the customer would silently get two of everything. The add button is a
   plain submit and the drawer owns it.

   Prices are not formatted here. Liquid renders each variant's price with
   the `money` filter into the JSON blob, so this only swaps text and never
   has to know about currency or decimal conventions.

   Delegated from the document so cards re-rendered by the Section Rendering
   API keep working without re-binding.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cardOf(el) { return el.closest('[data-pf-card]'); }

  function dataFor(card) {
    if (card.__pfData) return card.__pfData;
    var tag = card.querySelector('[data-pf-variants]');
    if (!tag) return null;
    try { card.__pfData = JSON.parse(tag.textContent); } catch (e) { card.__pfData = null; }
    return card.__pfData;
  }

  function setError(card, msg) {
    var box = card.querySelector('[data-pf-error]');
    if (box) box.textContent = msg || '';
  }

  /* ---------------- variant selection ---------------- */
  function selectVariant(card, variantId) {
    var variants = dataFor(card);
    if (!variants) return;

    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) { v = variants[i]; break; }
    }
    if (!v) return;

    var input = card.querySelector('[data-pf-id]');
    if (input) input.value = v.id;

    card.querySelectorAll('[data-pf-opt]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-pf-opt') === String(v.id)));
    });

    var price = card.querySelector('[data-pf-price]');
    if (price) price.textContent = v.price;

    var was = card.querySelector('[data-pf-was]');
    if (was) {
      if (v.compare) { was.textContent = v.compare; was.hidden = false; }
      else { was.textContent = ''; was.hidden = true; }
    }

    /* Swap to the variant's own image where it has one */
    if (v.image) {
      var main = card.querySelector('.pf-img--main');
      if (main && main.getAttribute('src') !== v.image) {
        main.setAttribute('src', v.image);
        main.removeAttribute('srcset');
      }
    }

    card.querySelectorAll('[data-pf-add], [data-pf-buy]').forEach(function (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold out';
    });

    setError(card, '');
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-pf-opt]');
    if (!pill || pill.disabled) return;
    var card = cardOf(pill);
    if (!card) return;
    e.preventDefault();
    selectVariant(card, pill.getAttribute('data-pf-opt'));
  });

  /* ---------------- buy now ----------------
     Adds, then goes straight to checkout. A plain fetch rather than a form
     submit so the cart drawer's submit interceptor does not open the drawer
     on the way past. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pf-buy]');
    if (!btn || btn.disabled) return;

    var card = cardOf(btn);
    if (!card) return;
    var input = card.querySelector('[data-pf-id]');
    if (!input || !input.value) return;

    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    setError(card, '');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        if (!res.ok) {
          setError(card, res.body.description || res.body.message || 'This item could not be added.');
          btn.removeAttribute('aria-busy');
          return;
        }
        window.location.href = ROOT + 'checkout';
      })
      .catch(function () {
        setError(card, 'Network error. Please try again.');
        btn.removeAttribute('aria-busy');
      });
  });

  /* Keep the drawer's own refresh in sync when a card adds normally */
  document.addEventListener('pmg:cart:changed', function () {
    document.querySelectorAll('[data-pf-card]').forEach(function (c) { setError(c, ''); });
  });
})();
